// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActionPlanNewActionMenu_wrapper__GrNwc {
  position: relative;
  margin-top: 12px;
}

.ActionPlanNewActionMenu_directWrapper__7nNnt {
  width: 100%;
}

.ActionPlanNewActionMenu_trigger__J4ehu,
.ActionPlanNewActionMenu_directTrigger__gV\\+Rk {
  width: 100%;
  min-height: 42px;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  border: 1px solid #d3dce3;
  border-radius: 8px;
  background: #fff;
  color: #284861;
  cursor: pointer;
  font-size: 0.88rem;
  text-align: left;
}

.ActionPlanNewActionMenu_trigger__J4ehu {
  display: grid;
  grid-template-columns: auto 1fr auto;
}

.ActionPlanNewActionMenu_directTrigger__gV\\+Rk {
  display: flex;
  justify-content: flex-start;
  min-height: 48px;
  border-color: #286786;
  font-weight: 600;
}

.ActionPlanNewActionMenu_directTrigger__gV\\+Rk > span:first-child {
  font-size: 1.25rem;
  font-weight: 400;
}

.ActionPlanNewActionMenu_directTrigger__gV\\+Rk:hover {
  background: #f7fbfd;
}

.ActionPlanNewActionMenu_chevron__PjBSu {
  color: #758792;
  font-size: 1rem;
}

.ActionPlanNewActionMenu_menu__\\+0nBX {
  position: absolute;
  z-index: 40;
  left: 0;
  right: 0;
  top: calc(100% + 6px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 10px 24px rgba(28, 48, 64, 0.16);
}

.ActionPlanNewActionMenu_menu__\\+0nBX button {
  padding: 13px 16px;
  border: 0;
  border-bottom: 1px solid #edf1f3;
  background: #fff;
  color: #142d3e;
  cursor: pointer;
  text-align: left;
  font-size: 0.86rem;
}

.ActionPlanNewActionMenu_menu__\\+0nBX button:last-child {
  border-bottom: 0;
}

.ActionPlanNewActionMenu_menu__\\+0nBX button:hover {
  background: #f7fafb;
}

.ActionPlanNewActionMenu_backdrop__1\\+R7Q {
  position: fixed;
  z-index: 2500;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(18, 37, 50, 0.52);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
}

.ActionPlanNewActionMenu_modal__n9wtS {
  position: relative;
  width: min(520px, 94vw);
  max-height: 92vh;
  overflow: auto;
  padding: 28px 24px 22px;
  border-top: 5px solid #5ab1d4;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 24px 64px rgba(15, 35, 48, 0.28);
  color: #243847;
}

.ActionPlanNewActionMenu_proposalModal__Wl7k1 {
  width: min(560px, 94vw);
  border-top-color: #ff8b43;
}

.ActionPlanNewActionMenu_close__TVwIN {
  position: absolute;
  top: 16px;
  right: 18px;
  border: 0;
  background: transparent;
  color: #8a99a5;
  cursor: pointer;
  font-size: 1.6rem;
}

.ActionPlanNewActionMenu_modal__n9wtS h2 {
  margin: 0 36px 20px 0;
  color: #173b52;
  font-size: 1.35rem;
}

.ActionPlanNewActionMenu_proposalModal__Wl7k1 h2 {
  margin-bottom: 4px;
  color: #3f3f3f;
  font-size: 1.8rem;
}

.ActionPlanNewActionMenu_subtitle__4TMDc {
  margin: 0 0 22px;
  padding-bottom: 18px;
  border-bottom: 1px solid #edf0f2;
  color: #75808a;
  font-size: 0.9rem;
}

.ActionPlanNewActionMenu_proposalTopBadges__YsL69 {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 18px;
}

.ActionPlanNewActionMenu_proposalTopBadges__YsL69 > span {
  padding: 6px 11px;
  border-radius: 8px;
  background: #f0f2f3;
  color: #525c64;
  font-size: 0.8rem;
  font-weight: 600;
}

.ActionPlanNewActionMenu_proposalTopBadges__YsL69 .ActionPlanNewActionMenu_valuePreview__N9IcA {
  background: var(--upcare-value-bienveillance-soft);
  color: #b57f00;
}

.ActionPlanNewActionMenu_field__syNps {
  display: block;
  margin-bottom: 16px;
}

.ActionPlanNewActionMenu_field__syNps > span:first-child {
  display: block;
  margin-bottom: 7px;
  color: #596976;
  font-size: 0.82rem;
  font-weight: 600;
}

.ActionPlanNewActionMenu_upperLabel__w7sW6 {
  color: #98a2b3 !important;
  font-size: 0.73rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
}

.ActionPlanNewActionMenu_field__syNps select,
.ActionPlanNewActionMenu_field__syNps input,
.ActionPlanNewActionMenu_field__syNps textarea {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #d7dfe5;
  border-radius: 10px;
  background: #f7f8fa;
  color: #415262;
  font: inherit;
}

.ActionPlanNewActionMenu_field__syNps select,
.ActionPlanNewActionMenu_field__syNps input {
  min-height: 40px;
  padding: 9px 12px;
}

.ActionPlanNewActionMenu_field__syNps textarea {
  min-height: 100px;
  resize: vertical;
  padding: 11px 12px;
}

.ActionPlanNewActionMenu_pills__vuI\\+C {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.ActionPlanNewActionMenu_pill__pk6KS,
.ActionPlanNewActionMenu_valuePill__De-BU,
.ActionPlanNewActionMenu_selectedNeutralPill__MFH5E,
.ActionPlanNewActionMenu_selectedActionPill__gUAtg,
.ActionPlanNewActionMenu_selectedThemePill__\\+UsRP {
  min-height: 34px;
  padding: 6px 14px;
  border-radius: 999px;
  background: #fff;
  border: 1px solid #dbe2e7;
  color: #515d66;
  cursor: pointer;
  font-size: 0.8rem;
}

.ActionPlanNewActionMenu_selectedNeutralPill__MFH5E {
  border-color: #f1ba2a;
  background: #fff7dc;
  color: #b78100;
}

.ActionPlanNewActionMenu_selectedActionPill__gUAtg {
  border-color: #ff8b43;
  background: #fff4ed;
  color: #e46a20;
}

.ActionPlanNewActionMenu_selectedThemePill__\\+UsRP {
  border-color: #2c6f88;
  background: #eaf5f9;
  color: #1d5b73;
  font-weight: 600;
}

.ActionPlanNewActionMenu_valuePill__De-BU[data-value="bienveillance"].ActionPlanNewActionMenu_selectedValuePill__Zrd3o {
  border-color: var(--upcare-value-bienveillance);
  background: var(--upcare-value-bienveillance-soft);
}

.ActionPlanNewActionMenu_valuePill__De-BU[data-value="engagement"].ActionPlanNewActionMenu_selectedValuePill__Zrd3o {
  border-color: var(--upcare-value-engagement);
  background: var(--upcare-value-engagement-soft);
}

.ActionPlanNewActionMenu_valuePill__De-BU[data-value="faire-equipe"].ActionPlanNewActionMenu_selectedValuePill__Zrd3o {
  border-color: var(--upcare-value-faire-equipe);
  background: var(--upcare-value-faire-equipe-soft);
}

.ActionPlanNewActionMenu_valuePill__De-BU[data-value="respect"].ActionPlanNewActionMenu_selectedValuePill__Zrd3o {
  border-color: var(--upcare-value-respect);
  background: var(--upcare-value-respect-soft);
}

.ActionPlanNewActionMenu_error__vDapd {
  margin: 4px 0 12px;
  padding: 9px 10px;
  border-radius: 8px;
  background: #fff0ef;
  color: #b42318;
  font-size: 0.8rem;
}

.ActionPlanNewActionMenu_submit__7LUM1 {
  width: 100%;
  min-height: 44px;
  border: 0;
  border-radius: 12px;
  background: #1a7188;
  color: #fff;
  cursor: pointer;
  font-weight: 700;
}

.ActionPlanNewActionMenu_submit__7LUM1:disabled {
  background: #acc3ce;
  cursor: not-allowed;
}

@media (max-width: 600px) {
  .ActionPlanNewActionMenu_backdrop__1\\+R7Q {
    align-items: flex-end;
    padding: 0;
  }

  .ActionPlanNewActionMenu_modal__n9wtS,
  .ActionPlanNewActionMenu_proposalModal__Wl7k1 {
    width: 100%;
    max-height: 94vh;
    border-radius: 16px 16px 0 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ActionPlan/ActionPlanNewActionMenu.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,QAAQ;EACR,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,kCAA0B;UAA1B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;;EAGE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;;;;EAKE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,kDAAkD;AACpD;;AAEA;EACE,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,8CAA8C;EAC9C,iDAAiD;AACnD;;AAEA;EACE,yCAAyC;EACzC,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,4BAA4B;EAC9B;AACF","sourcesContent":[".wrapper {\r\n  position: relative;\r\n  margin-top: 12px;\r\n}\r\n\r\n.directWrapper {\r\n  width: 100%;\r\n}\r\n\r\n.trigger,\r\n.directTrigger {\r\n  width: 100%;\r\n  min-height: 42px;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 9px 12px;\r\n  border: 1px solid #d3dce3;\r\n  border-radius: 8px;\r\n  background: #fff;\r\n  color: #284861;\r\n  cursor: pointer;\r\n  font-size: 0.88rem;\r\n  text-align: left;\r\n}\r\n\r\n.trigger {\r\n  display: grid;\r\n  grid-template-columns: auto 1fr auto;\r\n}\r\n\r\n.directTrigger {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  min-height: 48px;\r\n  border-color: #286786;\r\n  font-weight: 600;\r\n}\r\n\r\n.directTrigger > span:first-child {\r\n  font-size: 1.25rem;\r\n  font-weight: 400;\r\n}\r\n\r\n.directTrigger:hover {\r\n  background: #f7fbfd;\r\n}\r\n\r\n.chevron {\r\n  color: #758792;\r\n  font-size: 1rem;\r\n}\r\n\r\n.menu {\r\n  position: absolute;\r\n  z-index: 40;\r\n  left: 0;\r\n  right: 0;\r\n  top: calc(100% + 6px);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  border-radius: 12px;\r\n  background: #fff;\r\n  box-shadow: 0 10px 24px rgba(28, 48, 64, 0.16);\r\n}\r\n\r\n.menu button {\r\n  padding: 13px 16px;\r\n  border: 0;\r\n  border-bottom: 1px solid #edf1f3;\r\n  background: #fff;\r\n  color: #142d3e;\r\n  cursor: pointer;\r\n  text-align: left;\r\n  font-size: 0.86rem;\r\n}\r\n\r\n.menu button:last-child {\r\n  border-bottom: 0;\r\n}\r\n\r\n.menu button:hover {\r\n  background: #f7fafb;\r\n}\r\n\r\n.backdrop {\r\n  position: fixed;\r\n  z-index: 2500;\r\n  inset: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 24px;\r\n  background: rgba(18, 37, 50, 0.52);\r\n  backdrop-filter: blur(2px);\r\n}\r\n\r\n.modal {\r\n  position: relative;\r\n  width: min(520px, 94vw);\r\n  max-height: 92vh;\r\n  overflow: auto;\r\n  padding: 28px 24px 22px;\r\n  border-top: 5px solid #5ab1d4;\r\n  border-radius: 14px;\r\n  background: #fff;\r\n  box-shadow: 0 24px 64px rgba(15, 35, 48, 0.28);\r\n  color: #243847;\r\n}\r\n\r\n.proposalModal {\r\n  width: min(560px, 94vw);\r\n  border-top-color: #ff8b43;\r\n}\r\n\r\n.close {\r\n  position: absolute;\r\n  top: 16px;\r\n  right: 18px;\r\n  border: 0;\r\n  background: transparent;\r\n  color: #8a99a5;\r\n  cursor: pointer;\r\n  font-size: 1.6rem;\r\n}\r\n\r\n.modal h2 {\r\n  margin: 0 36px 20px 0;\r\n  color: #173b52;\r\n  font-size: 1.35rem;\r\n}\r\n\r\n.proposalModal h2 {\r\n  margin-bottom: 4px;\r\n  color: #3f3f3f;\r\n  font-size: 1.8rem;\r\n}\r\n\r\n.subtitle {\r\n  margin: 0 0 22px;\r\n  padding-bottom: 18px;\r\n  border-bottom: 1px solid #edf0f2;\r\n  color: #75808a;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.proposalTopBadges {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.proposalTopBadges > span {\r\n  padding: 6px 11px;\r\n  border-radius: 8px;\r\n  background: #f0f2f3;\r\n  color: #525c64;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.proposalTopBadges .valuePreview {\r\n  background: var(--upcare-value-bienveillance-soft);\r\n  color: #b57f00;\r\n}\r\n\r\n.field {\r\n  display: block;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.field > span:first-child {\r\n  display: block;\r\n  margin-bottom: 7px;\r\n  color: #596976;\r\n  font-size: 0.82rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.upperLabel {\r\n  color: #98a2b3 !important;\r\n  font-size: 0.73rem !important;\r\n  font-weight: 700 !important;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.field select,\r\n.field input,\r\n.field textarea {\r\n  width: 100%;\r\n  box-sizing: border-box;\r\n  border: 1px solid #d7dfe5;\r\n  border-radius: 10px;\r\n  background: #f7f8fa;\r\n  color: #415262;\r\n  font: inherit;\r\n}\r\n\r\n.field select,\r\n.field input {\r\n  min-height: 40px;\r\n  padding: 9px 12px;\r\n}\r\n\r\n.field textarea {\r\n  min-height: 100px;\r\n  resize: vertical;\r\n  padding: 11px 12px;\r\n}\r\n\r\n.pills {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n}\r\n\r\n.pill,\r\n.valuePill,\r\n.selectedNeutralPill,\r\n.selectedActionPill,\r\n.selectedThemePill {\r\n  min-height: 34px;\r\n  padding: 6px 14px;\r\n  border-radius: 999px;\r\n  background: #fff;\r\n  border: 1px solid #dbe2e7;\r\n  color: #515d66;\r\n  cursor: pointer;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.selectedNeutralPill {\r\n  border-color: #f1ba2a;\r\n  background: #fff7dc;\r\n  color: #b78100;\r\n}\r\n\r\n.selectedActionPill {\r\n  border-color: #ff8b43;\r\n  background: #fff4ed;\r\n  color: #e46a20;\r\n}\r\n\r\n.selectedThemePill {\r\n  border-color: #2c6f88;\r\n  background: #eaf5f9;\r\n  color: #1d5b73;\r\n  font-weight: 600;\r\n}\r\n\r\n.valuePill[data-value=\"bienveillance\"].selectedValuePill {\r\n  border-color: var(--upcare-value-bienveillance);\r\n  background: var(--upcare-value-bienveillance-soft);\r\n}\r\n\r\n.valuePill[data-value=\"engagement\"].selectedValuePill {\r\n  border-color: var(--upcare-value-engagement);\r\n  background: var(--upcare-value-engagement-soft);\r\n}\r\n\r\n.valuePill[data-value=\"faire-equipe\"].selectedValuePill {\r\n  border-color: var(--upcare-value-faire-equipe);\r\n  background: var(--upcare-value-faire-equipe-soft);\r\n}\r\n\r\n.valuePill[data-value=\"respect\"].selectedValuePill {\r\n  border-color: var(--upcare-value-respect);\r\n  background: var(--upcare-value-respect-soft);\r\n}\r\n\r\n.error {\r\n  margin: 4px 0 12px;\r\n  padding: 9px 10px;\r\n  border-radius: 8px;\r\n  background: #fff0ef;\r\n  color: #b42318;\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.submit {\r\n  width: 100%;\r\n  min-height: 44px;\r\n  border: 0;\r\n  border-radius: 12px;\r\n  background: #1a7188;\r\n  color: #fff;\r\n  cursor: pointer;\r\n  font-weight: 700;\r\n}\r\n\r\n.submit:disabled {\r\n  background: #acc3ce;\r\n  cursor: not-allowed;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .backdrop {\r\n    align-items: flex-end;\r\n    padding: 0;\r\n  }\r\n\r\n  .modal,\r\n  .proposalModal {\r\n    width: 100%;\r\n    max-height: 94vh;\r\n    border-radius: 16px 16px 0 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `ActionPlanNewActionMenu_wrapper__GrNwc`,
	"directWrapper": `ActionPlanNewActionMenu_directWrapper__7nNnt`,
	"trigger": `ActionPlanNewActionMenu_trigger__J4ehu`,
	"directTrigger": `ActionPlanNewActionMenu_directTrigger__gV+Rk`,
	"chevron": `ActionPlanNewActionMenu_chevron__PjBSu`,
	"menu": `ActionPlanNewActionMenu_menu__+0nBX`,
	"backdrop": `ActionPlanNewActionMenu_backdrop__1+R7Q`,
	"modal": `ActionPlanNewActionMenu_modal__n9wtS`,
	"proposalModal": `ActionPlanNewActionMenu_proposalModal__Wl7k1`,
	"close": `ActionPlanNewActionMenu_close__TVwIN`,
	"subtitle": `ActionPlanNewActionMenu_subtitle__4TMDc`,
	"proposalTopBadges": `ActionPlanNewActionMenu_proposalTopBadges__YsL69`,
	"valuePreview": `ActionPlanNewActionMenu_valuePreview__N9IcA`,
	"field": `ActionPlanNewActionMenu_field__syNps`,
	"upperLabel": `ActionPlanNewActionMenu_upperLabel__w7sW6`,
	"pills": `ActionPlanNewActionMenu_pills__vuI+C`,
	"pill": `ActionPlanNewActionMenu_pill__pk6KS`,
	"valuePill": `ActionPlanNewActionMenu_valuePill__De-BU`,
	"selectedNeutralPill": `ActionPlanNewActionMenu_selectedNeutralPill__MFH5E`,
	"selectedActionPill": `ActionPlanNewActionMenu_selectedActionPill__gUAtg`,
	"selectedThemePill": `ActionPlanNewActionMenu_selectedThemePill__+UsRP`,
	"selectedValuePill": `ActionPlanNewActionMenu_selectedValuePill__Zrd3o`,
	"error": `ActionPlanNewActionMenu_error__vDapd`,
	"submit": `ActionPlanNewActionMenu_submit__7LUM1`
};
export default ___CSS_LOADER_EXPORT___;
